import type { RouteRecordRaw } from "vue-router";

export const wordCloudsRoutes: RouteRecordRaw[] = [
  {
    path: "/word_clouds/info",
    name: "word_clouds-info",
    component: () => import("./info/WordCloudInfoPage.vue"),
    meta: {
      namespace: "word_clouds",
    },
  },
  {
    path: "/word_clouds/word_clouds",
    name: "word_clouds-index",
    component: () => import("./word_clouds/WordCloudListPage.vue"),
    meta: {
      requiresAuth: true,
      namespace: "word_clouds",
      title: "tools_meta.word_clouds_prefix",
    },
  },
  {
    path: "/word_clouds/word_clouds/:id",
    name: "word_clouds-show",
    component: () => import("./word_clouds/WordCloudLayout.vue"),
    meta: {
      requiresAuth: true,
      namespace: "word_clouds",
      title: "tools_meta.word_clouds_prefix",
    },
    children: [
      {
        path: "settings",
        name: "word_clouds-settings",
        component: () => import("./word_clouds/[id]/settings.vue"),
        meta: {
          requiresAuth: true,
          namespace: "word_clouds",
          title: "tools_meta.word_clouds_prefix",
        },
      },
      {
        path: "share",
        name: "word_clouds-share",
        component: () => import("./word_clouds/[id]/share.vue"),
        meta: {
          requiresAuth: true,
          namespace: "word_clouds",
          title: "tools_meta.word_clouds_prefix",
        },
      },
    ],
  },
  {
    path: "/word_clouds/public_word_clouds/:id",
    name: "word_clouds-public-show",
    component: () =>
      import("./public_word_clouds/[id]/PublicWordCloudPage.vue"),
    meta: {
      namespace: "word_clouds",
    },
  },
];
